import { getObjectUtil } from 'packages/src'

function getByIdReduxSelector (domainMapPath, id) {
  return (state) => getObjectUtil(state, domainMapPath)[id]
}

export default getByIdReduxSelector
